import React, { PureComponent, Fragment } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import cns from 'classnames';
import BasicSelect from '../../../../../../shared/components/formComponents/groups/BasicSelect';
import BasicText from '../../../../../../shared/components/formComponents/groups/BasicText';
import RawImageUpload from '../../../../../../shared/components/formComponents/inputs/RawImageUpload';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';

export default class QuestionItems extends PureComponent {
    static propTypes = {
        categories: PropTypes.array,
        deleteQuestion: PropTypes.func,
        fields: PropTypes.array,
        displayType: PropTypes.string,
        disabled: PropTypes.bool
    };

    render() {
        const { fields, displayType, categories, deleteQuestion, disabled } = this.props;
        return (
            <Fragment>
                {fields.map((question, index) => (
                    <div className={'answer-row row'}>
                        {displayType === 'image' ? (
                            <Field
                                component={RawImageUpload}
                                disableStyle={true}
                                name={`${question}.image`}
                                label={'Answer Image'}
                                disabled={disabled}
                                key={question}
                            />
                        ) : null}
                        <Field
                            name={`${question}.text`}
                            className={'col-5'}
                            label={'Answer Text'}
                            component={BasicText}
                            disabled={disabled}
                        />
                        <Field
                            name={`${question}.categoryId`}
                            label={'Answer Category'}
                            className={'col-5'}
                            options={categories}
                            valueKey={'id'}
                            labelKey={'name'}
                            component={BasicSelect}
                            disabled={disabled}
                            key={`${question}.categoryId`}
                        />
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                            className={'remove-answer-button'}
                            fontAwesomeIcon={'fa-trash-alt'}
                            onClick={() => fields.remove(index)}
                        />
                    </div>
                ))}
                <div className={'row'}>
                    <VerbButton
                        buttonText={'Add new answer'}
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                        fontAwesomeIcon={'fa-plus'}
                        onClick={() => fields.push({ image: '', text: '', categoryId: '' })}
                    />
                </div>
                <div className={cns('buttonCell col-12')} hidden={disabled}>
                    <VerbButton
                        fontAwesomeIcon={'fa-trash-alt'}
                        buttonText={'Remove Question'}
                        onClick={deleteQuestion}
                    />
                </div>
            </Fragment>
        );
    }
}
